import { httpRequest } from '@calendly/http-tools'

const MAX_USER_UUIDS_PER_REQUEST = 50

const chunkUserUuids = (userUuids, chunkSize) => {
  const chunks = []

  for (let index = 0; index < userUuids.length; index += chunkSize) {
    chunks.push(userUuids.slice(index, index + chunkSize))
  }

  return chunks
}

const fetchOrganizationMembershipsChunk = async (userUuids) => {
  const [success, response] = await httpRequest({
    url: '/api/organization/memberships',
    method: 'GET',
    params: {
      user_uuids: userUuids,
      page_size: userUuids.length,
    },
  })

  if (!success) {
    throw response
  }

  return response?.results ?? []
}

export const fetchOrganizationMembershipsByUserUuids = async (userUuids) => {
  const uniqueUserUuids = [...new Set(userUuids.filter(Boolean))]

  if (!uniqueUserUuids.length) {
    return []
  }

  const chunks = chunkUserUuids(uniqueUserUuids, MAX_USER_UUIDS_PER_REQUEST)
  const chunkResults = await Promise.all(chunks.map(fetchOrganizationMembershipsChunk))

  return chunkResults.flat()
}
